import { clearError, clearRegister, clearExistingUser } from "@mobile-dev/platform/common/redux/actions/CommonAction";
import { registerAction } from '@mobile-dev/platform/common/redux/actions/RegisterAction';
import React, { useEffect, useRef, useState } from 'react';
import Tooltip from '@mui/material/Tooltip';
import { useForm } from "react-hook-form";
import { injectIntl } from 'react-intl';
import { useDispatch, useSelector } from 'react-redux';
import { useLocation } from "react-router";
import { Link, useHistory } from 'react-router-dom';
import { toast } from "react-toastify";
import NewBrandLogo from '../../assets/images/FreightSmith_LOGO_Final.png';
import '../../styles/floating-labels.css';
import { AppConstatnt } from '../../Utils/AppConstant';
import { getApplicationFlow, getTheme, showAlert, stickyInfoAlert, TranslateAccent } from '../../Utils/Utility';
import { emailPattern, numberPattern, signupValidation, validStringPattern } from "../../Utils/ValidationUtils";
import ErrornDialog from '../Common/ErrorDialog/ErrorDialog';
import LoaderSubmitButton from "../Common/LoaderSubmitButton";
import MobileInput from '../Common/MobileInput/MobileInput';
import { getCarriersAction } from '@mobile-dev/platform/common/redux/actions/GetCarriers';
import { addCarrierAction } from '@mobile-dev/platform/common/redux/actions/AddCarrierAction';
import CreatableSelectCommon from "../Common/CreatableSelect/CreatableSelect";
import { checkforExistingUser } from "@mobile-dev/platform/common/redux/actions/AmplifyUserAction"

function Signup({ intl }) {

    const dispatch = useDispatch();
    const history = useHistory();
    const registrationData = useSelector(state => state.register);
    const errorStatus = useSelector(state => state.register.error);
    const getCarriers = useSelector(state => state.getcarrier)
    const [phone, setPhone] = useState("");
    const [dispatchPhone, setDispatchPhone] = useState("");
    const { register, handleSubmit, formState: { errors } } = useForm();
    const [isValid, setValid] = useState(true);
    const [emailError, setemailError] = useState("");
    const [phoneError, setPhoneError] = useState("");
    const location = useLocation();
    // const themeStyle = getTheme() === AppConstatnt.theme.DARK ? 'light' : '';
    const [carrierNameInput, setCarrierNameInput] = useState('');
    const [carrierOptions, setCarrierOptions] = useState([]);
    const [isLoading, setisLoading] = useState(false);
    const [creatableTheme, setCreatableTheme] = useState(getTheme())
    const ref = useRef();
    const themeStyle = getTheme() === AppConstatnt.theme.DARK ? 'light' : '';
    const { formatMessage } = intl;
    const captcha = useSelector(state => state.captcha.captcha);
    const [captchaData, setcaptchaData] = useState();
    const existingUser = useSelector(state => state.amplifyUser.existingUser)

    useEffect(() => {
        dispatch(clearError());
        if (location?.state?.mobileNumber) {
            setPhone(location.state.mobileNumber);
        }
    }, []);

    useEffect(() => {
        if (existingUser) {
            if (existingUser?.type === "EMAIL") {
                setemailError("")

            } else if (existingUser?.type === "PHONE") {
                setPhoneError("")
            }
            if (existingUser?.isExistingUser && existingUser?.type === "EMAIL") {
                setemailError(`${formatMessage({ id: "app.email_exist" })}`)
            } else if (existingUser?.isExistingUser && existingUser?.type === "PHONE") {
                setPhoneError(`${formatMessage({ id: "app.phone_number_exist" })}`)
            }
            dispatch(clearExistingUser())
        }
    }, [existingUser])

    useEffect(() => {
        if (captcha) {
            setcaptchaData(captcha)
        }
    }, [captcha])

    useEffect(() => {
        setCreatableTheme(getTheme())
    }, [getTheme()])

    useEffect(() => {
        if (getCarriers?.carriers) {
            customizeGetCarriers()
        }
    }, [getCarriers.carriers])

    // if (registrationData.user) {
    //     dispatch(clearError());
    //     history.push({
    //         pathname: '/Otp', state: {
    //             mobileNumber: registrationData.user.username,
    //             type: AppConstatnt.auth.SIGNUP,
    //             email: registrationData.user.username
    //         }
    //     });
    //     if (getApplicationFlow() === AppConstatnt.flow.CARRIER) {
    //         stickyInfoAlert(toast.TYPE.INFO, formatMessage({ id: "app.carrier_email_Sent_info" }, { email: registrationData.user.username }));
    //     }
    //     dispatch(clearRegister());
    //     return null;
    // }

    // if (registrationData?.signupAuthPayload) {
    //     dispatch(clearError());
    //     showAlert(toast.TYPE.WARNING, formatMessage({ id: "app.user_already_exist_error" }));
    //     if (getApplicationFlow() === AppConstatnt.flow.DRIVER) {
    //         history.push({ pathname: '/signin', state: { mobileNumber: phone.replace('+', '') } })
    //         return null;
    //     }
    //     else {
    //         history.push('/carrierLogin');
    //         return null;
    //     }

    // }

    const onSubmit = (data) => {
        if (emailError.length === 0 || (getApplicationFlow() === AppConstatnt.flow.DRIVER && phoneError.length === 0 && emailError.length === 0)) {
            if (getApplicationFlow() === AppConstatnt.flow.DRIVER) {
                data.mobileNumber = phone;
            }
            else if (getApplicationFlow() === AppConstatnt.flow.CARRIER) {
                data.carrierName = carrierNameInput?.label || '';
            }
            data.dispatchNumber = dispatchPhone;
            data.firstName = TranslateAccent(data.firstName);
            data.lastName = TranslateAccent(data.lastName);
            if (data.email === data.reenteremail) {
                delete data.reenteremail
                // dispatch(registerAction(data, getApplicationFlow()));
                navigateToCaptcha(data)

            }
            else {
                showAlert(toast.TYPE.WARNING, formatMessage({ id: "app.email_not_match" }))
            }
        }
    }

    const navigateToCaptcha = (registerData) => {
        if (captchaData.length > 0) {
            const randomID = Math.floor(Math.random() * captchaData.length);
            history.push({
                pathname: '/captcha', state: {
                    captchaData: captchaData[randomID],
                    isSignupFlow: true,
                    registerData: registerData,
                    phone: phone
                }
            });
        }
    }

    const handlePhone = (phone) => {
        if (getApplicationFlow() === AppConstatnt.flow.DRIVER) {
            if (phone.length >= 10) {
                const data = {
                    verificationType: "PHONE",
                    phone_number: "+" + phone
                }
                dispatch(checkforExistingUser(data))
            }
            setPhone(phone)
        } else { handleDispatchPhone(phone) }
    }

    const handleDispatchPhone = (phone) => {
        setDispatchPhone(phone);
    }

    const handleValid = (value) => {
        setValid(value);
    }

    const carrierNameHandler = (e) => {
        if (e) {
            setCarrierNameInput(e);
            if (e.length === 2) {
                setisLoading(true);
                dispatch(getCarriersAction(e));
            }
        }
    }

    const customizeGetCarriers = () => {
        if (getCarriers.carriers.length) {
            const customizedArray = getCarriers?.carriers.map(el => {
                return {
                    label: el.carrier_name,
                    value: el.carrier_id,
                    carrier_id: el.carrier_id,
                    carrier_name: el.carrier_name,
                }
            })
            setCarrierOptions(customizedArray);
            setisLoading(false);
        }
    }
    const createHandler = (e) => {
        setCarrierNameInput(e);
        if (e?.__isNew__) {
            dispatch(addCarrierAction({
                name: e.label,
                driver_phone: dispatchPhone
            }))
        }
    }

    const oProps = {
        creatableTheme,
        carrierNameInput, setCarrierNameInput,
        carrierOptions, setCarrierOptions,
        isLoading, setisLoading,
        ref,
        carrierNameHandler, createHandler,
        placeholderText: formatMessage({ id: "app.carrier_name_placeholder" }),
        defaultValue: [],
        name: formatMessage({ id: "app.carrier_name" }),
        formatCreateLabelText: () => `${formatMessage({ id: "app.carrier_name_formatCreateLabelText" })} "${carrierNameInput}"`,
        loadingMessageText: () => formatMessage({ id: "app.carrier_name_loadingMessageText" })
    }

    const onEmailInputBlur = (e) => {
        const data = {
            verificationType: "EMAIL",
            email: e.target.value
        }
        dispatch(checkforExistingUser(data))
    }

    return (
        <div data-layout-config='{"darkMode":false}'>
            <form className="form-signin" onSubmit={handleSubmit(onSubmit)}>
                <div className="card">

                    <div className="card-header uc-blue"></div>

                    <div className="card-header  text-center bg-header">
                        <span className="text-dark-50 fa-lg">
                            <img className="img-fluid smith_logo" src={NewBrandLogo} alt="FreightSmith logo" />
                        </span>
                    </div>
                    <div className="card-body p-4">
                        <div className="text-center m-auto">
                            <h4 className="text-dark-50 text-center mt-0 mb-3 font-weight-bold">{formatMessage({ id: "app.profile_info" })}</h4>
                            <p class="text-muted mb-4">{formatMessage({ id: "app.profile_content" })}</p>
                        </div>
                        <div className="col-lg-12 p-0 sign_up">
                            <div className="form-group">
                                <label htmlFor="firstName" className="mb-2 required"> <i
                                    className="fal fa-user fa-fw text-secondary font-22 align-middle"></i> {formatMessage({ id: "app.first_name" })} </label>
                                <Tooltip title={formatMessage({ id: "app.first_name_tooltip" })} enterTouchDelay={0} arrow>
                                    <input type="text"
                                        {...register("firstName", { required: true, pattern: validStringPattern })}
                                        className="form-control"
                                        placeholder={formatMessage({ id: "app.first_name_placeholder" })}
                                        autoFocus />

                                </Tooltip>
                            </div>
                            <div className="form-group">
                                <label htmlFor="lastName" className="mb-2 required">
                                    <i className="fal fa-user fa-fw text-secondary font-22 align-middle"></i> {formatMessage({ id: "app.last_name" })}
                                </label>
                                <Tooltip title={formatMessage({ id: "app.last_name_tooltip" })}
                                    enterTouchDelay={0} arrow>
                                    <input type="text" className="form-control"
                                        {...register("lastName", { required: true, pattern: validStringPattern })}
                                        placeholder={formatMessage({ id: "app.last_name_placeholder" })}
                                    />
                                </Tooltip>

                            </div>
                            <div className="form-group">
                                <label htmlFor="mobileNo" className="mb-2 required">
                                    <i className="fal fa-phone-alt fa-fw text-secondary font-22 align-middle"></i>{formatMessage({ id: "app.mobile_number" })}</label>

                                <MobileInput
                                    phone={phone}
                                    handlePhone={handlePhone}
                                    handleValid={handleValid}
                                />
                                {phoneError && <div className="error mb-2" style={{ color: "#f97474" }}>{phoneError}
                                    {
                                        getApplicationFlow() === AppConstatnt.flow.DRIVER && <Link to='/'>
                                            <span style={{ color: "#89CFF0" }}>
                                                {` ${formatMessage({ id: "app.click_to_signin" })}`}
                                            </span>
                                        </Link>
                                    }
                                </div>}
                            </div>
                            {getApplicationFlow() === AppConstatnt.flow.CARRIER &&
                                <div className="form-group">
                                    <label htmlFor="carrierName" className="mb-2 required">
                                        <i className="fal fa-user fa-fw text-secondary font-22 align-middle"></i>{formatMessage({ id: "app.carrier_name" })}
                                    </label>
                                    <Tooltip title={formatMessage({ id: "app.carrier_name_tooltip" })} enterTouchDelay={0} arrow placement="top">
                                        <div>
                                            <CreatableSelectCommon {...oProps} />
                                        </div>
                                    </Tooltip>

                                </div>
                            }

                            <div className="form-group">
                                <label htmlFor="email" className="mb-2 required">
                                    <i className="fal fa-envelope fa-fw text-secondary font-22 align-middle"></i> {formatMessage({ id: "app.email" })}</label>
                                <input type="email" className="form-control"
                                    {...register("email", { required: true, pattern: emailPattern, onBlur: onEmailInputBlur })}
                                />
                                <div className="d-flex flex-row">
                                    {emailError && <div className="error mb-2" style={{ color: "#f97474" }}>{emailError}
                                        {
                                            getApplicationFlow() !== AppConstatnt.flow.DRIVER && <Link to='/'>
                                                <span style={{ color: "#89CFF0" }}>
                                                    {` ${formatMessage({ id: "app.click_to_signin" })}`}
                                                </span>
                                            </Link>
                                        }
                                    </div>}
                                </div>
                            </div>
                            <div className="form-group">
                                <label htmlFor="reenteremail" className="mb-2 required">
                                    <i className="fal fa-envelope fa-fw text-secondary font-22 align-middle"></i> {formatMessage({ id: "app.re-enter_email" })}</label>
                                <input type="email" onBlur={onEmailInputBlur} className="form-control"
                                    {...register("reenteremail", { required: true, pattern: emailPattern })}
                                />
                            </div>
                            {getApplicationFlow() === AppConstatnt.flow.CARRIER &&

                                <div className="form-group">
                                    <label htmlFor="inputPassword" className="mb-2 required"><i
                                        className="fal fa-unlock-alt fa-fw text-secondary font-22 align-middle"></i>{formatMessage({ id: "app.password" })}</label>
                                    <input type="password" className="form-control"
                                        {...register("password", { required: true, minLength: 8, pattern: numberPattern })}
                                    />

                                </div>
                            }
                        </div>
                        {errors &&
                            Object.keys(errors).map(e => {
                                return signupValidation.filter(s => s.name === e).map(v =>
                                    <div key={v.name} className="error mb-2" style={{ color: "#f97474" }}>{v.message}</div>)
                            })
                        }

                        <LoaderSubmitButton
                            valid={isValid}
                            loading={registrationData.loading}
                            name={formatMessage({ id: "app.confirm" })}
                        />

                    </div>
                </div>
                <div className="row mt-3">
                    <div className="col-12 text-center">
                        <p className="text-muted d-flex align-items-center justify-content-center p-0">
                            <i className="fal fa-arrow-left fa-fw" style={{ fontSize: '1rem' }}></i> {formatMessage({ id: "app.back_to" })}
                            <Link to='/'>
                                <b className="text-orange ml-1">{formatMessage({ id: "app.sign_in" })}</b>
                            </Link>
                        </p>
                    </div>
                </div>
                <div className="row mt-3">
                    <h6 className="text-dark-50 text-center mt-0 mb-4"><span className="remaining_amt"> App Version {process.env.REACT_APP_VERSION}</span></h6>
                </div>
                {errorStatus || getCarriers?.error && <ErrornDialog
                    error={errorStatus}
                    open
                />}
            </form>
        </div>


    )
}

export default injectIntl(Signup);
